import { useContext } from "react";
import { AuthContext } from "contexts/AuthContext";

export function useAuthContext() {
  const authContext  = useContext(AuthContext);

  if (!authContext) {
    throw new Error("AuthContext.Provider is not found");
  }

  return authContext;
}